import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { getEmailPrefs, updateEmailPrefs } from "@/lib/api";

const CATS = [
  ["blog", "New blog articles", "Fresh Patrika articles as they publish"],
  ["whats_new", "What's new", "Notable new content & sections"],
  ["features", "New features", "Product updates and launches"],
  ["reminders", "Practice reminders", "Daily streak & practice nudges by email"],
  ["notifications", "Announcements", "Custom & system notifications"],
];

export default function EmailPreferences() {
  const [prefs, setPrefs] = useState(null);
  const [verified, setVerified] = useState(true);

  useEffect(() => {
    getEmailPrefs().then((d) => { setPrefs(d.email_prefs); setVerified(d.email_verified); }).catch(() => {});
  }, []);

  const toggle = async (k) => {
    const next = { ...prefs, [k]: !prefs[k] };
    setPrefs(next);
    try { await updateEmailPrefs({ [k]: next[k] }); } catch { /* ignore */ }
  };

  if (!prefs) return null;

  return (
    <div className="mt-10 border border-line bg-surface p-6" data-testid="account-email-prefs">
      <p className="inline-flex items-center gap-2 font-serif-latin text-lg text-ink"><Mail className="h-5 w-5 text-saffron" /> Email preferences</p>
      <p className="mt-1 text-sm text-ink-3">Choose which emails you'd like to receive. Account & donation receipts are always sent.</p>
      {!verified && <p className="mt-2 text-sm text-[var(--saffron-dark)]">Your email isn't confirmed yet — you won't receive these until you verify.</p>}
      <label className="mt-4 flex items-start justify-between gap-4 border border-[var(--gold)]/50 bg-parchment px-4 py-3" data-testid="email-pref-digest">
        <span>
          <span className="block text-sm font-medium text-ink">Weekly digest</span>
          <span className="block text-xs text-ink-3">Get ONE roundup email each week instead of a message per update (receipts & verification still send instantly)</span>
        </span>
        <input type="checkbox" checked={!!prefs.digest} onChange={() => toggle("digest")} data-testid="email-pref-toggle-digest" className="mt-1 h-5 w-5 shrink-0 accent-[var(--saffron)]" />
      </label>
      <div className="mt-4 space-y-2.5">
        {CATS.map(([k, label, desc]) => (
          <label key={k} className="flex items-start justify-between gap-4 border border-line px-4 py-3" data-testid={`email-pref-${k}`}>
            <span>
              <span className="block text-sm text-ink">{label}</span>
              <span className="block text-xs text-ink-3">{desc}</span>
            </span>
            <input type="checkbox" checked={!!prefs[k]} onChange={() => toggle(k)} data-testid={`email-pref-toggle-${k}`} className="mt-1 h-5 w-5 shrink-0 accent-[var(--saffron)]" />
          </label>
        ))}
      </div>
    </div>
  );
}
